export enum UserAddStep {
  SEARCH = 1,
  PRODUCTS = 2,
  FORM = 3,
}
